var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M13.333 9.778v2.37c0 .655-.53 1.185-1.185 1.185H3.852c-.655 0-1.185-.53-1.185-1.185v-2.37",
    transform: "translate(.667 .667)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "square",
    strokeWidth: 1.333,
    d: "M10.963 10.667L8 7.704 5.037 10.667",
    transform: "translate(.667 .667) matrix(1 0 0 -1 0 18.37)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M8 2.37L8 9.481",
    transform: "translate(.667 .667) matrix(1 0 0 -1 0 11.852)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z",
    transform: "translate(.667 .667)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWhite);
export default __webpack_public_path__ + "static/media/download-white.79504fac5e6dff22af54b11a601566a6.svg";
export { ForwardRef as ReactComponent };